import { gql } from 'graphql-request'

export const GET_USERS_TASKS_SPECTATORS_DEFAULTS = gql`
  query GET_USERS_TASKS_SPECTATORS_DEFAULTS(
    $take: Int
    $skip: Int
    $userTaskSpectatorType: UserTaskSpectatorType
    $name: String
    $description: String
    $typeFilterQuantity: TypeFilter
    $quantityInitial: Float
    $quantityFinal: Float
    $userTaskBonusType: UserTaskBonusType
    $itemPackageId: Int
    $typeFilterValue: TypeFilter
    $valueInitial: Float
    $valueFinal: Float
    $active: Boolean
    $deleted: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getUsersTasksSpectatorsDefaults(
      take: $take
      skip: $skip
      userTaskSpectatorType: $userTaskSpectatorType
      name: $name
      description: $description
      typeFilterQuantity: $typeFilterQuantity
      quantityInitial: $quantityInitial
      quantityFinal: $quantityFinal
      userTaskBonusType: $userTaskBonusType
      itemPackageId: $itemPackageId
      typeFilterValue: $typeFilterValue
      valueInitial: $valueInitial
      valueFinal: $valueFinal
      active: $active
      deleted: $deleted
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        active
        createdAt
        dateLastActive
        dateLastDelete
        deleted
        description
        iconUserTaskSpectator
        id
        itemPackageId
        name
        quantity
        updatedAt
        userTaskBonusType
        userTaskSpectatorType
        value
      }
    }
  }
`
